import { backAppHome } from '@/utils/connectAppFn';
import { getStuCenterUrl } from '@/utils/utils';

interface GoStudentCenterHomeParams {
  isAppEnv?: boolean;
}

export const goStudentCenterHome = (params?: GoStudentCenterHomeParams) => {
  const { isAppEnv = false } = params || {};
  if (isAppEnv) {
    backAppHome();
    return;
  }
  window.location.href = getStuCenterUrl();
};
